export enum AssistantCategoryTypes {
  ProgrammingLogic = 'logica-de-programacao',
  HtmlCssJs = 'html-css-js',
  React = 'react'
}
